import Vue from 'vue';
import VueRouter from 'vue-router';
import { AxiosError, AxiosResponse } from 'axios';
import vuexStore from '@/store';

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('../views/Login.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/resetpassword/:token',
        name: 'resetpassword',
        component: () => import('../views/ResetPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/Logout.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/Profile.vue'),
        meta: {
            requiresAuth: true,
            centeredHeading: true,
        },
    },
    {
        path: '/forms',
        name: 'forms',
        component: () => import('../views/Forms.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/form/:id',
        name: 'form_elements',
        component: () => import('../views/FormElements.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/form/:id/reporting',
        name: 'report_elements',
        component: () => import('../views/ReportElements.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/form/:id/entries',
        name: 'entries',
        component: () => import('../views/Entries.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('../views/Users.vue'),
        meta: {
            requiresAuth: true,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        return vuexStore
            .dispatch('account/auth')
            .then((r: any) => {
                if (r.response && r.response.status === 401) {
                    next('/');
                }
                return next();
            })
            .catch((error: AxiosError) => next('/'));
    }
    return next();
});

export default router;
